<div class="assign-dialog">
    <!-- HEADER -->
    <div class="dialog-header">
        <h2 *ngIf="step === 'select-candidate'">
            Sélectionner un professionnel
            <span class="mission-ref">— {{ mission?.missionTitle || 'Mission #' + mission?.id }}</span>
        </h2>
        <h2 *ngIf="step === 'select-dates'">
            Sélectionner les dates
            <span class="mission-ref">— {{ selectedCandidate?.firstname }} {{ selectedCandidate?.lastname }}</span>
        </h2>
        <h2 *ngIf="step === 'review'">
            Récapitulatif de l'affectation
            <span class="mission-ref">— {{ selectedCandidate?.firstname }} {{ selectedCandidate?.lastname }}</span>
        </h2>
        <h2 *ngIf="step === 'confirm'">
            Confirmer l'affectation
        </h2>
        <button class="close-btn" (click)="close()">✕</button>
    </div>

    <!-- STEP 1: SELECT CANDIDATE -->
    <div *ngIf="step === 'select-candidate'" class="dialog-body">
        <!-- Filters -->
        <div class="filters-row">
            <div class="search-field">
                <input type="text" class="form-control" placeholder="Rechercher par nom..." [(ngModel)]="searchName"
                    (input)="onSearchChange()" />
            </div>
            <div class="distance-field">
                <label>Distance max : <strong>{{ maxDistance }} km</strong></label>
                <input type="range" class="form-range" min="1" max="200" step="5" [(ngModel)]="maxDistance"
                    (change)="onDistanceChange()" />
            </div>
        </div>

        <!-- Loading -->
        <div *ngIf="isLoadingCandidates" class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
            <span>Chargement des professionnels...</span>
        </div>

        <!-- Candidates list -->
        <div *ngIf="!isLoadingCandidates" class="candidates-list">
            <div *ngIf="candidates.length === 0" class="empty-state">
                Aucun professionnel trouvé dans un rayon de {{ maxDistance }} km
            </div>
            <div *ngFor="let candidate of candidates" class="candidate-card"
                [class.ineligible]="!candidate.eligible && (!mission?.isfragmentable || candidate.ineligibilityReason !== 'Déjà affecté à une autre mission sur cette période')"
                (click)="(candidate.eligible || (mission?.isfragmentable && candidate.ineligibilityReason === 'Déjà affecté à une autre mission sur cette période')) ? selectCandidate(candidate) : null">
                <div class="candidate-avatar">
                    <img *ngIf="candidate.photoBase64" [src]="displayImg(candidate.photoBase64)"
                        alt="Photo" />
                    <div *ngIf="!candidate.photoBase64" class="avatar-placeholder">
                        {{ (candidate.firstname || '?')[0] }}{{ (candidate.lastname || '?')[0] }}
                    </div>
                </div>
                <div class="candidate-info">
                    <div class="candidate-name">{{ candidate.firstname }} {{ candidate.lastname }}</div>
                    <div class="candidate-meta">
                        <span *ngIf="candidate.profession">{{ candidate.profession }}</span>
                        <span *ngIf="candidate.phone"> • {{ candidate.phone }}</span>
                    </div>
                    <div *ngIf="!candidate.eligible" class="candidate-ineligible-reason">
                        ⚠️ {{ candidate.ineligibilityReason }}
                    </div>
                </div>
                <div class="candidate-distance">
                    <span class="distance-badge" [class.near]="candidate.distance < 20"
                        [class.medium]="candidate.distance >= 20 && candidate.distance < 50"
                        [class.far]="candidate.distance >= 50">
                        {{ candidate.distance }} km
                    </span>
                </div>
            </div>
        </div>

        <div class="total-count" *ngIf="!isLoadingCandidates && candidates.length > 0">
            {{ totalCandidates }} professionnel(s) trouvé(s)
        </div>
    </div>

    <!-- STEP 2: SELECT DATES (fragmentable missions) -->
    <div *ngIf="step === 'select-dates'" class="dialog-body">
        <div class="step-back" (click)="goBack()">← Retour à la liste</div>

        <div *ngIf="isLoadingAvailability" class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
            <span>Chargement du calendrier...</span>
        </div>

        <div *ngIf="!isLoadingAvailability" class="calendar-section">
            <div class="calendar-legend">
                <span class="legend-item"><span class="dot available"></span> Disponible</span>
                <span class="legend-item"><span class="dot selected"></span> Sélectionné</span>
                <span class="legend-item"><span class="dot assigned-self"></span> En attente de la confirmation</span>
                <span class="legend-item"><span class="dot assigned-other"></span> Déjà affecté</span>
                <span class="legend-item"><span class="dot non-available"></span> Non disponible</span>
            </div>

            <div class="calendar-actions">
                <button class="btn btn-sm btn-outline-primary" (click)="selectAllAvailable()">Tout sélectionner</button>
                <button class="btn btn-sm btn-outline-secondary" (click)="deselectAll()">Tout désélectionner</button>
            </div>

            <div class="calendar-grid">
                <div *ngFor="let day of calendarDays" class="calendar-day" [class.selectable]="day.isSelectable"
                    [class.selected]="isDateSelected(day)" [class.assigned-self]="day.isAssignedToSelected"
                    [class.assigned-other]="day.isAssignedToOther"
                    [class.non-available]="day.isNonAvailable" (click)="toggleDate(day)">
                    <span class="day-label">{{ day.label }}</span>
                    <span *ngIf="day.isAssignedToSelected && day.status === 'SIGNED'" class="day-status signed-status">✓ Signé</span>
                    <span *ngIf="day.isAssignedToSelected && day.status === 'ACCEPTED'" class="day-status">En attente de la confirmation</span>
                    <span *ngIf="day.isAssignedToOther" class="day-status">Déjà affecté</span>
                    <span *ngIf="day.isNonAvailable" class="day-status">Indisponible</span>
                    <!-- 48H countdown badge — visible only on ACCEPTED (not yet signed) assigned-self days -->
                    <span *ngIf="day.isAssignedToSelected && day.countdownText && day.status === 'ACCEPTED'"
                          class="countdown-badge"
                          [class.countdown-ok]="day.countdownUrgency === 'ok'"
                          [class.countdown-warning]="day.countdownUrgency === 'warning'"
                          [class.countdown-urgent]="day.countdownUrgency === 'urgent'"
                          [class.countdown-expired]="day.countdownUrgency === 'expired'">
                        ⏱ {{ day.countdownText }}
                    </span>
                </div>
            </div>

            <div class="selected-count">
                {{ selectedDates.size }} jour(s) sélectionné(s)
            </div>
        </div>
    </div>

    <!-- STEP: REVIEW (fragmentable — summary before confirm) -->
    <div *ngIf="step === 'review'" class="dialog-body">
        <div class="step-back" (click)="goBack()">← Retour à la sélection des dates</div>

        <div class="confirm-section">
            <div class="confirm-summary">
                <div class="confirm-row">
                    <span class="confirm-label">Mission</span>
                    <span>{{ mission?.missionTitle }}</span>
                </div>
                <div class="confirm-row">
                    <span class="confirm-label">Professionnel</span>
                    <span>{{ selectedCandidate?.firstname }} {{ selectedCandidate?.lastname }}</span>
                </div>
                <div class="confirm-row">
                    <span class="confirm-label">Distance</span>
                    <span>{{ selectedCandidate?.distance }} km</span>
                </div>
                <div class="confirm-row">
                    <span class="confirm-label">Jours sélectionnés</span>
                    <div class="selected-dates-list">
                        <span *ngFor="let d of selectedDatesArray" class="date-chip">{{ d }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- STEP 3: CONFIRM (non-fragmentable missions) -->
    <div *ngIf="step === 'confirm'" class="dialog-body">
        <div class="step-back" (click)="goBack()">← Retour à la liste</div>

        <div *ngIf="isLoadingAvailability" class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
        </div>

        <div *ngIf="!isLoadingAvailability" class="confirm-section">
            <div class="confirm-summary">
                <div class="confirm-row">
                    <span class="confirm-label">Mission</span>
                    <span>{{ mission?.missionTitle }}</span>
                </div>
                <div class="confirm-row">
                    <span class="confirm-label">Professionnel</span>
                    <span>{{ selectedCandidate?.firstname }} {{ selectedCandidate?.lastname }}</span>
                </div>
                <div class="confirm-row">
                    <span class="confirm-label">Distance</span>
                    <span>{{ selectedCandidate?.distance }} km</span>
                </div>
                <div class="confirm-row">
                    <span class="confirm-label">Dates</span>
                    <!-- No `:'UTC'` here — backend sends ISO strings without a zone (e.g.
                         "2026-07-01T00:00:00") which JS parses as LOCAL midnight. Forcing
                         UTC then displays the previous day in any TZ east of UTC. The list
                         view uses moment() in local time and shows the correct day; this
                         pipe (default local) now matches. -->
                    <span>{{ mission?.startdate | date:'dd/MM/yyyy' }} — {{ mission?.enddate | date:'dd/MM/yyyy' }}</span>
                </div>
            </div>

            <div *ngIf="hasCalendarConflict && isConflictWithSameMission" class="conflict-warning">
                ⚠️ Ce professionnel a un conflit de calendrier sur les dates de cette mission car cette mission est déjà affectée à ce candidat. <br>
                Annulation automatique après : ⏱ {{getRemainingTimeString(missionExpiresAt)}}
            </div>
            <div *ngIf="hasCalendarConflict && !isConflictWithSameMission" class="conflict-warning conflict-blocked">
                ⚠️ Ce professionnel a un conflit de calendrier sur les dates de cette mission.
                L'affectation n'est pas possible.
            </div>
        </div>
    </div>

    <!-- FOOTER -->
    <div class="dialog-footer">
        <button class="btn btn-secondary" (click)="step === 'select-candidate' ? close() : goBack()">
            {{ step === 'select-candidate' ? 'Annuler' : 'Retour' }}
        </button>
        <!-- Fragmentable: after date selection, go to review first -->
        <button class="btn btn-primary" *ngIf="step === 'select-dates'" [disabled]="selectedDates.size === 0"
            (click)="goToReview()">
            Continuer
        </button>
        <!-- Review or non-fragmentable confirm: actual assignment (hidden when conflict blocks it) -->
        <button class="btn btn-primary" *ngIf="(step === 'confirm' || step === 'review') && canConfirm"
            [disabled]="isAssigning" (click)="confirmAssignment()">
            <span *ngIf="!isAssigning">Confirmer l'affectation</span>
            <span *ngIf="isAssigning">Affectation en cours...</span>
        </button>
    </div>

    <!-- CONFIRMATION OVERLAY — shown after user clicks "Confirmer l'affectation" -->
    <div *ngIf="showConfirmOverlay" class="assign-overlay">
        <div class="assign-overlay-card" *ngIf="!showProgressLoader">
            <div class="assign-overlay-icon">?</div>
            <h3 class="assign-overlay-title">Confirmer l'affectation</h3>
            <p class="assign-overlay-text">
                Êtes-vous sûr(e) de vouloir affecter
                <strong>{{ selectedCandidate?.firstname }} {{ selectedCandidate?.lastname }}</strong>
                à la mission
                <strong>{{ mission?.missionTitle || 'Mission #' + mission?.id }}</strong> ?
            </p>
            <p class="assign-overlay-subtext" *ngIf="mission?.isfragmentable">
                {{ selectedDates.size }} jour(s) sélectionné(s)
            </p>
            <div class="assign-overlay-actions">
                <button class="btn btn-secondary" (click)="cancelConfirm()">Non</button>
                <button class="btn btn-primary" (click)="proceedWithAssignment()">Oui</button>
            </div>
        </div>

        <!-- Rotating progress loader shown while the backend processes the assignment -->
        <div class="assign-overlay-card assign-overlay-loader" *ngIf="showProgressLoader">
            <mat-spinner diameter="56"></mat-spinner>
            <p class="assign-overlay-loader-text">{{ progressMessage }}</p>
            <p class="assign-overlay-subtext">Merci de patienter, ne fermez pas cette fenêtre.</p>
        </div>
    </div>
</div>